
import * as fromAuth from '@store/auth/reducers';
import * as fromSpinner from '@store/spinner/reducers';
import * as fromProgram from '@store/program/reducers';
import * as fromStudent from '@store/student/reducers';
import * as fromTeacher from '@store/teacher/reducers';
import * as fromSubscription from '@store/subscription/reducers';

export interface AppState {
  auth: fromAuth.State;
  spinner: fromSpinner.State;
  program: fromProgram.State;
  student: fromStudent.State;
  teacher: fromTeacher.State;
  subscription: fromSubscription.State;
}

export const reducers = {
  auth: fromAuth.reducer,
  spinner: fromSpinner.reducer,
  program: fromProgram.reducer,
  student: fromStudent.reducer,
  teacher: fromTeacher.reducer,
  subscription: fromSubscription.reducer,
};
